import { createFileRoute } from '@tanstack/react-router'
import { SUB_CUSTOMER_AUDIENCE, SubCustomersDashboardPage } from '@spcc/domains/dashboards/sales'

export const Route = createFileRoute('/customers-dashboard')({
  component: CustomersDashboardPage,
})

function CustomersDashboardPage() {
  return <SubCustomersDashboardPage audience={SUB_CUSTOMER_AUDIENCE.CUSTOMER} />
}
